import _ from 'lodash'

export const MessageBoardFeedPageMode = {
  Add: 'Add',
  Edit: 'Edit',
  Delete: 'Delete',
  Unchanged: 'Unchanged'
}

export const MessageTagText = (info) => {
  let messageTagText = ''
  _.forEach(info, (a) => {
    if (messageTagText === '') {
      messageTagText = a.label
    } else {
      messageTagText = `${messageTagText}, ${a.label}`
    }
  })
  return messageTagText
}

export const increaseViewCount = async (CountViews, messageKey) => {
  CountViews(messageKey)
}

export const splitLoginIds = (type, dataInfo) => {
  let typeText = ''
  if (type === 'Phone') {
    _.forEach(dataInfo, (d) => {
      if (isNaN(d) === false && d.length === 10) {
        if (typeText === '') {
          typeText = d
        } else {
          typeText = `${typeText}, ${d}`
        }
      }
    })
  } else if (type === 'Email') {
    _.forEach(dataInfo, (d) => {
      if (d.includes('@')) {
        if (typeText === '') {
          typeText = d
        } else {
          typeText = `${typeText}, ${d}`
        }
      }
    })
  } else if (type === 'Login') {
    _.forEach(dataInfo, (d) => {
      if (isNaN(d) === true && !d.includes('@')) {
        if (typeText === '') {
          typeText = d
        } else {
          typeText = `${typeText}, ${d}`
        }
      }
    })
  }
  return typeText
}
